export default __webpack_public_path__ + "static/assets/SL-parked-truck.706e94c4.png";